import { apiFetch } from "./client";

export async function fetchCities(limit = 200, page = 1) {
  const params = new URLSearchParams();

  params.set("limit", String(limit));
  params.set("page", String(page));

  return apiFetch<string[]>(`/api/cities?${params.toString()}`);
}

export async function fetchFeaturedCities(limit = 12, around?: string | null) {
  const params = new URLSearchParams();

  params.set("limit", String(limit));
  if (typeof around === "string" && around.trim().length > 0) {
    params.set("around", around.trim());
  }

  return apiFetch<string[]>(`/api/cities/featured?${params.toString()}`);
}

export async function searchCities(query: string, limit = 50, page = 1) {
  const params = new URLSearchParams();

  params.set("q", query);
  params.set("limit", String(limit));
  params.set("page", String(page));

  return apiFetch<string[]>(`/api/cities?${params.toString()}`);
}

export async function fetchSubjects(limit = 200, page = 1) {
  const params = new URLSearchParams();

  params.set("limit", String(limit));
  params.set("page", String(page));

  return apiFetch<string[]>(`/api/subjects?${params.toString()}`);
}

export async function fetchPopularSubjects(limit = 12) {
  const params = new URLSearchParams();

  params.set("limit", String(limit));

  return apiFetch<string[]>(`/api/subjects/popular?${params.toString()}`);
}

export async function searchSubjects(query: string, limit = 50, page = 1) {
  const params = new URLSearchParams();

  params.set("q", query);
  params.set("limit", String(limit));
  params.set("page", String(page));

  return apiFetch<string[]>(`/api/subjects?${params.toString()}`);
}

export async function fetchCityBySlug(slug: string) {
  return apiFetch<{ name: string; population?: number }>(
    `/api/cities/slug/${slug}`,
  );
}

export async function fetchSubjectBySlug(slug: string) {
  return apiFetch<{ name: string }>(`/api/subjects/slug/${slug}`);
}
